<template>
  <div class="page w-full">
    <div class="flex justify-end">
      <el-button type="primary"
                 class="border border-purple-600 bg-transparent hover:bg-transparent h-15 w-1/12 rounded-xl">
        自定义房间
      </el-button>
    </div>

    <div class="">
      <div class="flex overflow-x-auto py-2 space-x-4 gap-x-3 mt-1">
        <div v-for="(item, index) in list" :key="index"
             class="flex-shrink-0 text-center flex flex-col items-center justify-center bg-gray-500 rounded-3xl gap-y-2 h-1/2 w-1/4 relative">
          <img class="w-full h-full rounded-md" :src="item.img" mode="aspectFill"/>
          <div class="absolute bottom-4 w-full left-0 pt-5 pb-2 pl-5 pr-5 gap-x-4 flex items-center justify-center">
            <el-button type="primary"
                       class="border border-purple-600 bg-transparent hover:bg-transparent h-15 w-1/2 rounded-xl">
              预览
            </el-button>
            <el-button type="primary" class="bg-purple-600 hover:bg-purple-700 border-none h-15 w-1/2 rounded-xl">
              应用
            </el-button>
          </div>
        </div>
      </div>
      <div class="flex overflow-x-auto py-2 space-x-4 gap-x-3">
        <div v-for="(item, index) in list" :key="index"
             class="flex-shrink-0 text-center flex flex-col items-center justify-center bg-gray-500 rounded-3xl gap-y-2 h-1/2 w-1/4 relative">
          <img class="w-full h-full rounded-md" :src="item.img" mode="aspectFill"/>

          <div class="absolute bottom-4 w-full left-0 pt-5 pb-2 pl-5 pr-5 gap-x-4 flex items-center justify-center">
            <el-button type="primary"
                       class="border border-purple-600 bg-transparent hover:bg-transparent h-15 w-1/2 rounded-xl">
              预览
            </el-button>
            <el-button type="primary" class="bg-purple-600 hover:bg-purple-700 border-none h-15 w-1/2 rounded-xl">
              应用
            </el-button>

          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'roomDesign',
  data() {
    return {
      list: [
        {img: 'http://qzctec.com:8085/defaultAvatar/1.png', name: 'OPENAI'},
        {img: 'http://qzctec.com:8085/defaultAvatar/1.png', name: 'OPENAI'},
        {img: 'http://qzctec.com:8085/defaultAvatar/1.png', name: 'OPENAI'},
        {img: 'http://qzctec.com:8085/defaultAvatar/1.png', name: 'OPENAI'},
        {img: 'http://qzctec.com:8085/defaultAvatar/1.png', name: 'OPENAI'},
        {img: 'http://qzctec.com:8085/defaultAvatar/1.png', name: 'OPENAI'},
      ],
      list1: [
        {img: 'http://qzctec.com:8085/defaultAvatar/1.png', name: 'OPENAI'},
        {img: 'http://qzctec.com:8085/defaultAvatar/1.png', name: 'OPENAI'},
        {img: 'http://qzctec.com:8085/defaultAvatar/1.png', name: 'OPENAI'},
        {img: 'http://qzctec.com:8085/defaultAvatar/1.png', name: 'OPENAI'},
        {img: 'http://qzctec.com:8085/defaultAvatar/1.png', name: 'OPENAI'},
        {img: 'http://qzctec.com:8085/defaultAvatar/1.png', name: 'OPENAI'},
      ],
    }
  }
}
</script>

<style scoped>

</style>